import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, Pagination, Skeleton, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import Page from '../../component/Page'
import api from '../../api/api'
export default function CustomerList() {
    const [data, setData] = useState([])
    // const [name, setName] = useState('')
    // const [page, setPage] = React.useState(1);
    const [searchParams, setSearchParams] = useSearchParams()

    let name = searchParams.get('name') || ''
    let page = searchParams.get('page') || '1'
    let id = searchParams.get('id') || ''

    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [loading, setLoading] = useState(false);
    const getData = async () => {
        setLoading(true)
        const res = await api.get(`non-agent-customers?name=${name}&page=${page}&limit=${10}`)
        const data = await res.data.result
        if (res.data.status === true) {
            setData(data)
            setLoading(false)
        }
    }
    useEffect(() => {
        getData()
    }, [name, page])
    return (
        <Page>
            <div class="container-fluid">

                <div class=" d-flex row justify-content-between align-items-baseline">
                    <div class="col-lg-5 col-md-12 text-left ">
                        <label class="title-content mb-4">
                            รายการลูกค้า
                        </label>
                    </div>
                    <div class="col-lg-3 col-md-12 text-end px-4">
                        <Link to={`/agent/customer-list/add`}>
                            <Button type="button" className="ButtomSearch" variant='contained'>+ เพิ่มรายการ</Button>
                        </Link>
                    </div>
                    <div class="col-lg-4 col-md-12">
                        <Box className='backgroundField'>
                            <TextField value={name || ''} onChange={e => setSearchParams({ name: e.target.value })} variant="standard" fullWidth placeholder="ค้นหา ลูกค้า"
                                InputProps={{
                                    disableUnderline: true,
                                    startAdornment: <Box sx={{ marginRight: '10px' }}><FontAwesomeIcon icon={faSearch} /></Box>,
                                }}
                            />
                        </Box>
                    </div>
                </div>

                <div class="listData row">
                    {loading ? <Skeleton variant="rounded" sx={{ width: '100%', height: '70vh' }} /> :
                        <div class="col-md-12 table-responsive-sm pb-3">
                            <table class="table table-borderless table-hover ">
                                <thead>
                                    <tr>
                                        <th scope="col ">ที่</th>
                                        {/* <th scope="col ">รหัสสมาชิก</th> */}
                                        <th scope="col ">ศูนย์เมล็ดพันธุ์ข้าว</th>
                                        <th scope="col ">ชื่อ - นามสกุล</th>
                                        <th scope="col ">ที่อยู่</th>
                                        <th scope="col ">ประเภทลูกค้า</th>
                                        <th scope="col ">เบอร์โทรศัพท์</th>
                                        <th scope="col ">สถานะ</th>
                                        <th scope="col ">ดำเนินการ</th>


                                    </tr>
                                </thead>
                                <tbody class="">
                                    {data?.items?.map((x, i) => (
                                        <tr className={id === x?.CustomerNo ? 'active' : ''}>
                                            <td class="text-center">{(data?.meta?.currentPage - 1) * data?.meta?.itemsPerPage + 1 + i}</td>
                                            {/* <td class="text-center">{x?.CustomerNo}</td> */}
                                            <td class="text-center">{x?.BranchName}</td>
                                            <td class="text-center">{x?.CustomerFName} {x?.CustomerLName}</td>
                                            <td class="text-center">{`จ. ${x?.Province ? x?.Province : '-'} อ. ${x?.District ? x?.District : '-'}`}</td>
                                            <td class="text-center">{x?.CustomerTypeName}</td>
                                            <td class="text-center">{x?.Tel}</td>
                                            <td class="text-center">
                                                {x?.Status === 'Y' ? <span class="status-active">
                                                    ปกติ
                                                </span> : <span class="status-inactive">
                                                    ยกเลิก
                                                </span>}
                                            </td>
                                            <td class="text-center">
                                                <Link to={`/agent/customer-list/${x?.CustomerNo}`} onClick={() => setSearchParams({ id: x?.CustomerNo, page: page, name: name, })}>
                                                    <Button variant='contained' sx={{ background: '#fbbe66', ':hover': { background: '#eda844' } }}>เรียกดู</Button>
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}

                                </tbody>
                            </table >
                        </div >}
                    <div class="col-md-12 text-center mt-4">
                        <Pagination sx={{ display: 'flex', justifyContent: 'center' }} color="primary" count={data?.meta?.totalPages} page={+page} onChange={(event, value) => setSearchParams({ page: value, name: name, id: id })} shape="rounded" />

                    </div >
                </div >
            </div >
        </Page >
    )
}
